"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.assert = void 0;
const _assert = require("assert");
/**
 * Typed assertion function.
 */
function assert(condition, msg) {
    _assert(condition, msg);
}
exports.assert = assert;
//# sourceMappingURL=assert.js.map